import { doc } from "src/global"

export default (src: string, callback?: () => void) => {
  const head = doc.head || doc.getElementsByTagName('head')[0];
  const scriptEl = doc.createElement('script');

  scriptEl.type = 'text/javascript'
  scriptEl.crossOrigin = 'anonymous';
  scriptEl.async = true;

  scriptEl.onload = callback;
  scriptEl.src = src;
  head.appendChild(scriptEl);
}
